/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetBookingResult } from '../../models/get-booking-result';

export interface GetByBookingid$Params {
  SiteName?: string;
  BookingId: number;
}

export function getByBookingid(
  http: HttpClient,
  rootUrl: string,
  params: GetByBookingid$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<GetBookingResult>> {
  const rb = new RequestBuilder(rootUrl, getByBookingid.PATH, 'get');
  if (params) {
    rb.query('SiteName', params.SiteName, {});
    rb.path('BookingId', params.BookingId, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetBookingResult>;
    }),
  );
}

getByBookingid.PATH = '/Bookings/{BookingId}';
